<template>
  <v-footer :padless="padless">
    <v-col cols="12" offset-md="1" md="2" align="center">
      <router-link to="/">
        <v-img
          src="../assets/df-logo-sm.png"
          max-width="75"
        ></v-img>
      </router-link>
      <p>
        <small>
          &copy; {{ new Date().getFullYear() }} DoleFund
        </small>
      </p>
    </v-col>
    <v-col cols="12" offset-md="2" md="3" align="center">
      <p>
        <router-link to="/organizations">
          Organizations
        </router-link>
      </p>
      <p>
        <router-link to="/subscribe">
          Register
        </router-link>
      </p>
    </v-col>
    <v-col cols="12" offset-md="1" md="3" align="center">
      <p>
        <router-link to="/about">
          About
        </router-link>
      </p>
      <p>
        <a href="mailto:hello@dolefund.com">hello@dolefund.com</a>
      </p>
    </v-col>
  </v-footer>
</template>

<script>
  export default {
    name: 'Footer',
    data: () => ({
      padless: true
    })
  }
</script>

<style>
footer {
  border-top: 2px solid #111 !important;
}

footer a {
  font-weight: normal;
}
</style>